import unique from "lodash/uniq";
import { inView as layerInView } from "ol/layer/Layer";
export default function getVisibleLayersFromFramestate(frameState) {
    return unique(frameState.layerStatesArray
        .filter((layerState) => layerInView(layerState, frameState.viewState))
        .map(({ layer }) => layer));
}
